import * as React from 'react';
import styles from './index.less';
import img_1_banner from './1.banner@2x.png';
import img_2_introduction from './2.introduction@2x.png';
import img_3_datetime from './3.datetime@2x.png';
import img_4_1_guidebook from './4.1.guidebook@2x.png';
import img_4_2_guidebook from './4.2.guidebook@2x.png';
import img_4_3_guidebook from './4.3.guidebook@2x.png';
import img_4_4_guidebook from './4.4.guidebook@2x.png';
import img_4_guidebook_commit from './4.guidebook.commit@2x.png';
import img_4_guidebook_commitDisabled from './4.guidebook.commitDisabled@2x.png';
import img_4_guidebook_lookOver from './4.guidebook.lookOver@2x.png';
import img_4_guidebook_submit from './4.guidebook.submit@2x.png';
import img_5_1_prize from './5.1.prize@2x.png';
import img_5_2_prize from './5.2.prize@2x.png';
import img_5_3_prize from './5.3.prize@2x.png';
import img_5_4_prize from './5.4.prize@2x.png';
import img_5_5_prize from './5.5.prize@2x.png';
// 查看公示
import img_5_prize_lookOver from './5.prize.lookOver@2x.png';
import img_6_rule from './6.rule@2x.png';
import img_7_FAQ from './7.FAQ@2x.png';
import img_QQChatQR from '@/assets/activity/SpringFestival/QQChatQR.jpg';
import img_weixinQR from '@/assets/activity/SpringFestival/weixinQR.jpg';
import img_tool_feedback from './tool_feedback@2x.png';
import img_tool_share from './tool_share@2x.png';
import img_tool_submit from './tool_submit@2x.png';
import FPropaganda from './FPropaganda';
import FPageFooter from './FPageFooter';
import { connect } from 'umi';
import { ConnectState, ActivityDetailsPageModelState, UserModelState } from '@/models/connect';
import ImgButton from './ImgButton';
import TextButton from './TextButton';
import * as AHooks from 'ahooks';
import { FServiceAPI, FUtil } from '@freelog/tools-lib';
import copy from 'copy-to-clipboard';
import fCenterMessage from '@/components/fCenterMessage';
import fWeiXinShare from '@/components/fWeiXinShare';
import { Modal } from 'antd';
import FSimpleBar from '@/components/FSimpleBar';
import AnnounceContent from './AnnounceContent';
import dayjs from 'dayjs';

interface MoonFestival2025Props {
  activityDetailsPage: ActivityDetailsPageModelState;
  user: UserModelState;
}

function MoonFestival2025({ activityDetailsPage, user }: MoonFestival2025Props) {
  const ref_content1 = React.useRef<HTMLImageElement>(null);
  const ref_content2 = React.useRef<HTMLDivElement>(null);
  const ref_content3 = React.useRef<HTMLDivElement>(null);
  const ref_content4 = React.useRef<HTMLDivElement>(null);
  const ref_content5 = React.useRef<HTMLDivElement>(null);
  const ref_content6 = React.useRef<HTMLDivElement>(null);
  const ref_content_finalist = React.useRef<HTMLImageElement>(null);

  const [$activated, set$activated, get$activated] = FUtil.Hook.useGetState<number>(1);

  const [$isLogined, set$isLogined, get$isLogined] = FUtil.Hook.useGetState<boolean>(false);
  const [$isRegister, set$isRegister, get$isRegister] = FUtil.Hook.useGetState<boolean>(false);

  // const [$isShowWechatShareModal, set$isShowWechatShareModal, get$isShowWechatShareModal] =
  //   FUtil.Hook.useGetState<boolean>(false);

  const [$announceShow, set$announceShow, get$announceShow] =
    FUtil.Hook.useGetState<boolean>(false);
  const [$momentTime, set$momentTime, get$momentTime] =
    FUtil.Hook.useGetState<dayjs.Dayjs>(dayjs());

  AHooks.useMount(async () => {
    if (FUtil.Tool.getUserIDByCookies() === -1) {
      return;
    }
    set$isLogined(true);
    const {
      data,
    }: {
      data: {
        userType: 0 | 1;
      };
    } = await FServiceAPI.User.currentUserInfo();
    set$isRegister(data.userType === 1);
  });

  const position = AHooks.useScroll(
    self.document.querySelector('#layout-content .simplebar-content-wrapper'),
  );

  React.useEffect(() => {
    const info1 = ref_content1.current?.getBoundingClientRect();
    const info2 = ref_content2.current?.getBoundingClientRect();
    const info3 = ref_content3.current?.getBoundingClientRect();
    const info4 = ref_content4.current?.getBoundingClientRect();
    const info5 = ref_content5.current?.getBoundingClientRect();
    const info6 = ref_content6.current?.getBoundingClientRect();
    if (info6 && info6.top <= 72) {
      set$activated(6);
    } else if (info5 && info5.top <= 72) {
      set$activated(5);
    } else if (info4 && info4.top <= 72) {
      set$activated(4);
    } else if (info3 && info3.top <= 72) {
      set$activated(3);
    } else if (info2 && info2.top <= 72) {
      set$activated(2);
    } else {
      set$activated(1);
    }
  }, [position]);

  function scrollTo(top: number) {
    self.document.querySelector('#layout-content .simplebar-content-wrapper')?.scrollBy({
      top,
      behavior: 'smooth',
    });
  }

  return (
    <>
      <div className={styles.styles}>
        <img src={img_1_banner} alt='' className={styles.img_1_banner} />
        <img
          src={img_2_introduction}
          alt=''
          className={styles.img_2_introduction}
          ref={ref_content1}
        />
        <div className={styles.img_3_datetime} ref={ref_content2}>
          <img src={img_3_datetime} alt='' />
          <div className={styles.img_3_datetime_box}>
            <div>
              {activityDetailsPage.activityDateTime.collecting_startTime?.format(
                'YYYY-MM-DD HH:mm',
              ) || 'YYYY-MM-DD HH:mm'}
            </div>
            <div>
              {activityDetailsPage.activityDateTime.collecting_endTime?.format(
                'YYYY-MM-DD HH:mm',
              ) || 'YYYY-MM-DD HH:mm'}
            </div>
            <div>
              {activityDetailsPage.activityDateTime.announcing?.format('YYYY-MM-DD HH:mm') ||
                'YYYY-MM-DD HH:mm'}
            </div>
          </div>
        </div>
        <div className={styles.img_4_guidebook} ref={ref_content3}>
          <img src={img_4_1_guidebook} alt='' />
          <img src={img_4_2_guidebook} alt='' />
          <img src={img_4_3_guidebook} alt='' />
          <img src={img_4_4_guidebook} alt='' ref={ref_content_finalist} />
          <div className={styles.img_4_guidebook_box} style={{ top: 360 }}>
            {$isRegister && (
              <ImgButton
                img={img_4_guidebook_commitDisabled}
                // hoverImg={img_4_guidebook_commit_hover}
                width={204}
                height={64}
                disabled={true}
                onClick={async () => {}}
                alt='已获通行证'
              />
            )}
            {!$isRegister && (
              <ImgButton
                img={img_4_guidebook_commit}
                // hoverImg={img_4_guidebook_commit_hover}
                width={204}
                height={64}
                onClick={async () => {
                  const {
                    data,
                  }: {
                    data: {
                      userType: 0 | 1;
                    };
                  } = await FServiceAPI.User.currentUserInfo();

                  if (FUtil.Tool.getUserIDByCookies() === -1) {
                    return;
                  }

                  self.open(
                    FUtil.Format.completeUrlByDomain('console') +
                      FUtil.LinkTo.invitation() +
                      '?type=apply',
                  );
                }}
                alt='获取通行证'
              />
            )}
          </div>
          <div className={styles.img_4_guidebook_box} style={{ bottom: 446 }}>
            <ImgButton
              img={img_4_guidebook_lookOver}
              // hoverImg={img_4_guidebook_lookOver_hover}
              width={204}
              height={64}
              onClick={() => {
                self.open(
                  'https://freelog3.freelog.cn/reader_freelog-query_id=62d0d04f456ff0002e329537&title=1.+%E5%A6%82%E4%BD%95%E5%88%9B%E5%BB%BA%E5%8F%91%E8%A1%8C%E5%8D%95%E4%B8%AA%E8%B5%84%E6%BA%90?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f&w06c513=%2F',
                );
              }}
              alt='查看教程'
            />
            <ImgButton
              img={img_4_guidebook_submit}
              // hoverImg={img_4_guidebook_submit_hover}
              width={204}
              height={64}
              onClick={() => {
                self.open(
                  FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.resourceCreatorEntry(),
                );
              }}
              alt='立即投稿'
            />
          </div>
          <TextButton
            text='查看入围标准'
            size='large'
            style={{
              position: 'absolute',
              bottom: 1240,
              right: 238,
              transform: 'translateY(-50%)',
            }}
            onClick={() => {
              const info = ref_content_finalist.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          />
          <TextButton
            text='复制活动标签'
            size='large'
            style={{
              position: 'absolute',
              bottom: 553,
              right: 140,
              transform: 'translateY(-50%)',
            }}
            onClick={() => {
              copy(`#Freelog中秋创作游园会#`, {
                format: 'text/plain',
              });
              fCenterMessage({ message: '复制成功' });
            }}
          />
        </div>
        <div className={styles.img_5_prize} ref={ref_content4}>
          <img src={img_5_1_prize} alt='' />
          <img src={img_5_2_prize} alt='' />
          <img src={img_5_3_prize} alt='' />
          <img src={img_5_4_prize} alt='' />
          <img src={img_5_5_prize} alt='' />
          <div
            className={styles.img_5_prize_box}
            style={{
              bottom: 660,
              justifyContent: 'space-between',
              // padding: '0 100px',
              paddingLeft: 276,
              paddingRight: 290,
            }}
          >
            <TextButton
              text='前往反馈建议区'
              size='medium'
              onClick={() => {
                self.open(
                  'https://forum.freelog.cn/category/3/%E5%8F%8D%E9%A6%88%E5%BB%BA%E8%AE%AE%E5%8C%BA',
                );
              }}
            />
            <TextButton
              text='了解展品合集'
              size='medium'
              onClick={() => {
                self.open(
                  'https://freelog3.freelog.cn/?theme=%2Freader%3Fid%25M262ce6f8a456ff0002e32915f%25M1title%25M23.3%2B%E6%B7%BB%E5%8A%A0%E5%B1%95%E5%93%81%E5%90%88%E9%9B%86&w06c513=%2F',
                );
              }}
            />
          </div>
          <div className={styles.img_5_prize_box} style={{ bottom: 60, height: 64 }}>
            {$momentTime.isAfter(activityDetailsPage.activityDateTime.announcing || $momentTime) ? (
              <ImgButton
                img={img_5_prize_lookOver}
                // hoverImg={img_5_prize_lookOver_hover}
                width={204}
                height={64}
                onClick={() => {
                  set$announceShow(true);
                }}
              />
            ) : (
              <div
                style={{
                  fontWeight: 600,
                  fontSize: 26,
                  color: '#8F420B',
                  lineHeight: '37px',
                }}
              >
                获奖公示时间：
                {activityDetailsPage.activityDateTime.announcing?.format('YYYY-MM-DD HH:mm') ||
                  'YYYY-MM-DD HH:mm'}
                ，敬请期待
              </div>
            )}
          </div>
        </div>
        <div className={styles.img_6_rules} ref={ref_content5}>
          <img src={img_6_rule} alt='' />

          <div className={styles.img_6_rule_box_text} style={{ top: 296, left: 474 }}>
            {activityDetailsPage.activityDateTime.collecting_startTime?.format(
              'YYYY-MM-DD HH:mm',
            ) || 'YYYY-MM-DD HH:mm'}
          </div>

          <div className={styles.img_6_rule_box_text} style={{ top: 296, left: 664 }}>
            {activityDetailsPage.activityDateTime.collecting_endTime?.format('YYYY-MM-DD HH:mm') ||
              'YYYY-MM-DD HH:mm'}
          </div>

          <div className={styles.img_6_rule_box_text} style={{ top: 349, left: 460 }}>
            {activityDetailsPage.activityDateTime.announcing?.format('YYYY-MM-DD HH:mm') ||
              'YYYY-MM-DD HH:mm'}
          </div>

          <div className={styles.img_6_rule_box}>
            <TextButton
              text='查看《Freelog平台管理规范》'
              size='medium'
              onClick={() => {
                self.open(
                  'https://freelog2.freelog.cn/reader_freelog-query_id=62cce8f2456ff0002e328eb2?theme=%2Freader%3Fid%25M262cce8f2456ff0002e328eb2&w63518a=%2F',
                );
              }}
            />
            <TextButton
              text='复制邮箱地址 service@freelog.com'
              size='medium'
              onClick={() => {
                copy('service@freelog.com', {
                  format: 'text/plain',
                });
                fCenterMessage({ message: '复制成功' });
              }}
            />
          </div>
        </div>
        <div className={styles.img_7_FAQ} ref={ref_content6}>
          <img src={img_7_FAQ} alt='' />
          <div className={styles.img_7_FAQ_box}>
            <div className={styles.img_7_FAQ_box_item}>
              <img src={img_QQChatQR} alt='' />
            </div>
            <div className={styles.img_7_FAQ_box_item}>
              <img src={img_weixinQR} alt='' />
            </div>
          </div>
        </div>

        <div style={{ backgroundColor: 'rgba(255,255,255,0.4)', width: '100%' }}>
          <FPropaganda />
          <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
            <div style={{ border: '1px solid #979797', width: 780, opacity: 0.15 }} />
          </div>
          <FPageFooter />
        </div>

        <div className={styles.navs}>
          <div
            className={[styles.navs_item, $activated === 1 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content1.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动介绍
          </div>
          <div className={styles.navs_item_divider} />
          <div
            className={[styles.navs_item, $activated === 2 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content2.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动时间
          </div>
          <div className={styles.navs_item_divider} />
          <div
            className={[styles.navs_item, $activated === 3 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content3.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动指南
          </div>
          <div className={styles.navs_item_divider} />
          <div
            className={[styles.navs_item, $activated === 4 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content4.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动奖励
          </div>
          <div className={styles.navs_item_divider} />
          <div
            className={[styles.navs_item, $activated === 5 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content5.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动规则
          </div>
          <div className={styles.navs_item_divider} />
          <div
            className={[styles.navs_item, $activated === 6 ? styles.navs_item_active : ''].join(
              ' ',
            )}
            onClick={() => {
              const info = ref_content6.current?.getBoundingClientRect();
              scrollTo((info?.top || 0) - 70);
            }}
          >
            活动答疑
          </div>
        </div>

        <img
          src={img_tool_submit}
          alt=''
          className={styles.img_tool}
          style={{
            bottom: 92,
            right: 30,
            width: 140,
            height: 140,
          }}
          onClick={() => {
            self.open(
              FUtil.Format.completeUrlByDomain('console') + FUtil.LinkTo.resourceCreatorEntry(),
            );
          }}
        />
        <img
          src={img_tool_share}
          alt=''
          className={styles.img_tool}
          style={{
            bottom: 30,
            right: 105,
            width: 65,
            height: 52,
          }}
          title='分享活动'
          onClick={async () => {
            if (!user.userInfo) {
              await FServiceAPI.User.currentUserInfo();
              return;
            }
            self._czc?.push(['_trackEvent', '中秋活动页', '分享活动', user.userInfo.username, 1]);
            // set$isShowWechatShareModal(true);
            fWeiXinShare({
              configs: {
                title: activityDetailsPage.pageTitle,
                desc: activityDetailsPage.description,
                link: self.location.href,
                imgUrl: activityDetailsPage.cover,
              },
            });
            await FServiceAPI.Activity.pushMessageTask({
              taskConfigCode: 'T0001004',
              meta: { activityId: activityDetailsPage.activityID },
            });
          }}
        />
        <img
          src={img_tool_feedback}
          alt=''
          className={styles.img_tool}
          style={{
            bottom: 30,
            right: 30,
            width: 65,
            height: 52,
          }}
          title='反馈建议'
          onClick={() => {
            self.open(
              'https://forum.freelog.cn/category/3/%E5%8F%8D%E9%A6%88%E5%BB%BA%E8%AE%AE%E5%8C%BA',
            );
          }}
        />
      </div>

      <Modal
        // open={true}
        open={$announceShow}
        title={null}
        footer={null}
        width={1000}
        centered={true}
        style={{ borderRadius: 10, overflow: 'hidden' }}
        styles={{
          body: {
            padding: 0,
            height: '100%',
            width: '100%',
          },
          content: {
            padding: 0,
            height: 'calc(100vh - 200px)',
            width: '100%',
          },
        }}
        onCancel={() => {
          set$announceShow(false);
        }}
      >
        <FSimpleBar>
          <AnnounceContent />
        </FSimpleBar>
      </Modal>
    </>
  );
}

export default connect(({ activityDetailsPage, user }: ConnectState) => ({
  activityDetailsPage,
  user,
}))(MoonFestival2025);
